var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC380"
    },
    d: "M344.265,255.139H214.283c-6.774,0-12.71-4.531-14.496-11.065c-1.786-6.534,1.02-13.455,6.851-16.902 c56.633-33.464,86.05-72.5,89.93-119.338c1.353-16.255,15.831-29.239,32.266-29.024c16.77,0.268,32.481,6.99,44.248,18.93 c11.776,11.951,18.266,27.777,18.272,44.561c0,0.002,0,0.004,0,0.006v5.049c0,41-12.144,67.142-34.551,101.04 C354.018,252.607,349.311,255.139,344.265,255.139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCF99"
    },
    d: "M503.562,272.171c0-25.964-21.123-47.088-47.088-47.088H214.283c-2.691,0-5.333,0.722-7.648,2.092 c-17.001,10.052-34.167,18.327-47.96,24.978c-4.811,2.319-9.355,4.51-13.488,6.576c-5.091,2.546-8.307,7.749-8.307,13.442v192.359 c0,5.693,3.216,10.896,8.307,13.442C205.91,508.329,256.386,512,315.247,512c9.115,0,18.437-0.088,28.023-0.178 c10.602-0.1,21.563-0.204,33.055-0.204h47.509c25.964,0,47.088-21.123,47.088-47.088c0-8.73-2.387-16.912-6.545-23.929 c13.529-8.282,22.575-23.199,22.575-40.191c0-8.73-2.387-16.912-6.545-23.929c13.529-8.282,22.575-23.199,22.575-40.191 c0-12.212-4.673-23.353-12.324-31.728C498.99,295.781,503.562,284.328,503.562,272.171z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29CCB1"
    },
    d: "M472.303,141.117h-32.06c-8.299,0-15.028-6.729-15.028-15.028s6.729-15.028,15.028-15.028h32.06 c8.299,0,15.028,6.729,15.028,15.028S480.603,141.117,472.303,141.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29CCB1"
    },
    d: "M247.884,141.117h-32.06c-8.299,0-15.028-6.729-15.028-15.028s6.729-15.028,15.028-15.028h32.06 c8.299,0,15.028,6.729,15.028,15.028S256.185,141.117,247.884,141.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29CCB1"
    },
    d: "M295.989,57.826c-5.195,0-10.245-2.695-13.028-7.516l-16.03-27.765 c-4.15-7.187-1.687-16.379,5.5-20.528c7.187-4.15,16.379-1.687,20.528,5.5l16.03,27.765c4.15,7.187,1.687,16.379-5.5,20.528 C301.123,57.177,298.538,57.826,295.989,57.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29CCB1"
    },
    d: "M392.139,57.826c-2.55,0-5.134-0.649-7.5-2.016c-7.187-4.15-9.65-13.341-5.5-20.528l16.03-27.765 c4.149-7.187,13.341-9.652,20.528-5.5c7.187,4.15,9.65,13.341,5.5,20.528l-16.03,27.765 C402.386,55.131,397.333,57.826,392.139,57.826z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#73C3FF"
    },
    d: "M102.613,432.66v79.148H72.557V432.66c0-8.295,6.733-15.028,15.028-15.028 S102.613,424.365,102.613,432.66z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29CCB1"
    },
    d: "M472.303,141.117h-32.06c-8.299,0-15.028-6.729-15.028-15.028s6.729-15.028,15.028-15.028h32.06 c8.299,0,15.028,6.729,15.028,15.028S480.603,141.117,472.303,141.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29CCB1"
    },
    d: "M247.884,141.117h-32.06c-8.299,0-15.028-6.729-15.028-15.028s6.729-15.028,15.028-15.028h32.06 c8.299,0,15.028,6.729,15.028,15.028S256.185,141.117,247.884,141.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29CCB1"
    },
    d: "M295.989,57.826c-5.195,0-10.245-2.695-13.028-7.516l-16.03-27.765 c-4.15-7.187-1.687-16.379,5.5-20.528c7.187-4.15,16.379-1.687,20.528,5.5l16.03,27.765c4.15,7.187,1.687,16.379-5.5,20.528 C301.123,57.177,298.538,57.826,295.989,57.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#29CCB1"
    },
    d: "M392.139,57.826c-2.55,0-5.134-0.649-7.5-2.016c-7.187-4.15-9.65-13.341-5.5-20.528l16.03-27.765 c4.149-7.187,13.341-9.652,20.528-5.5c7.187,4.15,9.65,13.341,5.5,20.528l-16.03,27.765 C402.386,55.131,397.333,57.826,392.139,57.826z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#73C3FF"
    },
    d: "M102.613,432.66v79.148H72.557V432.66c0-8.295,6.733-15.028,15.028-15.028 S102.613,424.365,102.613,432.66z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44A4EC"
    },
    d: "M151.705,225.083H23.466c-8.295,0-15.028,6.733-15.028,15.028v256.478 c0,8.305,6.733,15.028,15.028,15.218h96.179c18.424-0.19,34.404-10.82,42.129-26.269c3.176-6.322,4.959-13.465,4.959-21.009V240.111 C166.733,231.815,160,225.083,151.705,225.083z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73C3FF"
    },
    d: "M102.613,431.658v80.15H72.557v-80.15c0-8.295,6.733-15.028,15.028-15.028 S102.613,423.363,102.613,431.658z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.d799eee5b9b9adead92b8ab17ed9f18c.svg";
export { ForwardRef as ReactComponent };